import { emotionTheme } from '@styles/theme'

export type PreviewCardType = 'budget' | 'preview' | 'detour'

export const getColorsByType = (type: PreviewCardType, isNegative?: boolean) => {
  const colors = {
    budget: {
      text: emotionTheme.colors.secondary,
      color: emotionTheme.colors.secondary,
      background: emotionTheme.colors.gray.light
    },
    preview: {
      text: emotionTheme.colors.secondary,
      color: emotionTheme.colors.orange.color,
      background: emotionTheme.colors.orange.background
    },
    detour: {
      text: isNegative ? emotionTheme.colors.error.color : emotionTheme.colors.success.color,
      color: isNegative ? emotionTheme.colors.error.color : emotionTheme.colors.success.color,
      background: isNegative ? emotionTheme.colors.error.background : emotionTheme.colors.success.background
    }
  }

  return colors[type]
}
